/* Emir ICE — refonte 2 univers — comportements de l'ACCUEIL et des pages d'entrée (2026-10-12)
   1. Révélation douce des blocs « .eix-rv » au défilement (IntersectionObserver ; sans lui, tout est visible).
   2. Onglets des sélections (« [data-eix-tabs] ») : clic + flèches du clavier, aria-selected tenu à jour.
   La classe « eix-js » est posée sur <html> par un petit script du <head> (layout/theme.liquid) pour éviter tout clignotement.
   InstantClick remplace le <body> sans recharger : init() est rejouée à chaque changement de page ; les écouteurs globaux ne sont posés qu'une fois. */
(function () {
  'use strict';
  if (window.__eixHome) { if (typeof window.__eixHome === 'function') window.__eixHome(); return; }

  var io = null;

  function reveal(root) {
    var els = (root || document).querySelectorAll('.eix-rv:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px 12% 0px', threshold: 0.01 });
    }
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  function initTabs(root) {
    var boxes = (root || document).querySelectorAll('[data-eix-tabs]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.__eixTabs) return;
      box.__eixTabs = true;
      var tabs = box.querySelectorAll('[role="tab"]');
      if (!tabs.length) return;
      function select(tab, focus) {
        Array.prototype.forEach.call(tabs, function (t) {
          var on = t === tab;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.classList.toggle('is-on', on);
        });
        if (focus) tab.focus();
      }
      Array.prototype.forEach.call(tabs, function (t, i) {
        t.setAttribute('tabindex', t.classList.contains('is-on') ? '0' : '-1');
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = tabs.length, to = -1;
          if (k === 'ArrowRight' || k === 'ArrowDown') to = (i + 1) % n;
          else if (k === 'ArrowLeft' || k === 'ArrowUp') to = (i - 1 + n) % n;
          else if (k === 'Home') to = 0;
          else if (k === 'End') to = n - 1;
          if (to > -1) { e.preventDefault(); select(tabs[to], true); }
        });
      });
    });
  }

  function init() {
    if (window.__eixJsT) { clearTimeout(window.__eixJsT); window.__eixJsT = 0; }
    document.documentElement.classList.add('eix-js');
    initTabs(document);
    reveal(document);
  }

  window.__eixHome = init;
  function boot() {
    init();
    if (window.InstantClick && typeof window.InstantClick.on === 'function') {
      window.InstantClick.on('change', function () { io = null; init(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
